import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';

/**
 * Layout route that renders the persistent TopBar above every nested
 * route's <Outlet>. Used for everything except landing + auth pages.
 */
function AppShell() {
  return (
    <div className="flex min-h-full flex-col bg-surface text-on-surface">
      <TopBar />
      <Outlet />
    </div>
  );
}

export default AppShell;
